import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {QuotationService} from "../../../../services/quotation-service/quotation.service";
import {ValidationService} from "../../../../services/validation-service/validation.service";
import {VehicleSmartSearchResponse} from "../../../../model/VehicleSmartSearchResponse";
import {VehicleSelectItem} from "../../../../model/VehicleSelectItem";
import {isNullOrUndefined} from "util";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";
import {BehaviorSubject} from "rxjs";
import {ErrorMessages} from "../../../../model/ErrorMessages";

@Component({
  selector: 'app-search-by-make',
  templateUrl: './search-by-make.component.html'
})
export class SearchByMakeComponent implements OnInit {

  vehicleSearchTerm: BehaviorSubject<string> = new BehaviorSubject<string>('');
  vehicleList: BehaviorSubject<VehicleSelectItem[]> = new BehaviorSubject<VehicleSelectItem[]>([]);
  loadingVehicleSearch = false;
  vehicleSearched = false;
  errorMessage = ErrorMessages;
  @Input() vehicleNotFoundByRegOrVin = false;
  @ViewChild('openModal') openModal: ElementRef;

  constructor(public router: Router,
              public quotationService: QuotationService,
              public validationService: ValidationService) { }

  ngOnInit() {
    this.vehicleSearchTerm.pipe(debounceTime(1000),
      distinctUntilChanged()).subscribe(term => {
      this.vehicleSearch(term);
    });
  }

  vehicleInputChange(value: any) {
    this.vehicleSearchTerm.next(value);
  }

  public vehicleSearch(phrase: string): void {
    if (phrase.length >= 4) {
      // clean any special chars from the input
      phrase = phrase.replace(/[^a-zA-Z0-9\.\\\/\'\s\,]/g, '');
      this.loadingVehicleSearch = true;
      this.quotationService.searchVehicleByMakeModelYear({"maxResultsCount": 10, "searchString": phrase}).subscribe((response: VehicleSmartSearchResponse) => {
        if (response.vehicleSelectItemList && response.vehicleSelectItemList.length > 0) {
          this.vehicleSearched = true;
          this.loadingVehicleSearch = false;
          this.vehicleList.next(response.vehicleSelectItemList);
        } else {
          this.openModal.nativeElement.click();
          this.quotationService.scrollToTop();
          this.loadingVehicleSearch = false;
        }
      }, error => {
        this.openModal.nativeElement.click();
        this.quotationService.scrollToTop();
        this.loadingVehicleSearch = false;
      })
    }
  }

  public selectVehicle(vehicle: VehicleSelectItem) {
    if (!isNullOrUndefined(vehicle)) {
      this.quotationService.getQuoteVehicleAndDriverDetails.vehicle.itemDescription = vehicle.label;
      this.quotationService.getQuoteVehicleAndDriverDetails.vehicle.modelRangeYearCd = parseInt(vehicle.key);
      this.validationService.clearErrors();
      this.validationService.vehicleSelectValue = vehicle.label;
    }
    this.vehicleList.next([]);
  }


}

